import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './style.scss';

import React from 'react';
import Slider from 'react-slick';

function PrevArrow({ className, onClick, compact }) {
  const customClass =
    className +
    ' carousel__arrow carousel__arrow--left' +
    (compact ? ' carousel__arrow--compact' : '');
  return (
    <div className={customClass} onClick={onClick}>
      <div className="icon-arrow-left" />
    </div>
  );
}

function NextArrow({ className, onClick, compact }) {
  const customClass =
    className +
    ' carousel__arrow carousel__arrow--right' +
    (compact ? ' carousel__arrow--compact' : '');
  return (
    <div className={customClass} onClick={onClick}>
      <div className="icon-arrow-right" />
    </div>
  );
}

class Carousel extends React.Component {
  componentDidMount() {
    this.resize();
  }

  componentDidUpdate(prevProps) {
    const prevKeys = (prevProps.children || []).map(c => c.key);
    const keys = (this.props.children || []).map(c => c.key);
    if (keys.join() !== prevKeys.join()) {
      this.reset();
      this.resize();
    }
  }

  resize() {
    /* https://github.com/akiran/react-slick/issues/809 */
    /* https://github.com/akiran/react-slick/issues/254 */
    if (
      this.slick.innerSlider &&
      typeof this.slick.innerSlider.onWindowResized === 'function'
    ) {
      this.slick.innerSlider.onWindowResized();
    }
  }

  reset() {
    if (this.slick && typeof this.slick.slickGoTo === 'function') {
      this.slick.slickGoTo(0);
    }
  }

  render() {
    const {
      dots,
      lazyLoad,
      slidesToShow,
      slidesToScroll,
      responsive,
      arrows,
      compact,
      autoplay,
      infinite,
      className,
      children
    } = this.props;

    const settings = {
      dots: dots || false,
      infinite: typeof infinite === 'undefined' ? false : infinite,
      speed: 500,
      swipe: false,
      lazyLoad,
      slidesToShow,
      slidesToScroll,
      responsive,
      autoplay,
      arrows: typeof arrows === 'undefined' ? true : arrows,
      prevArrow: <PrevArrow compact={compact} />,
      nextArrow: <NextArrow compact={compact} />,
      className: 'carousel' + (className ? ` ${className}` : '')
    };

    return (
      <Slider {...settings} ref={div => (this.slick = div)}>
        {children}
      </Slider>
    );
  }
}

Carousel.defaultProps = {
  lazyLoad: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } }
  ]
};

export default Carousel;
